import React from "react";
import { faTrashCan } from "@fortawesome/pro-regular-svg-icons";
import "./PlayerSlots.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { ButtonNew } from "components/buttonNew";
import { Badge } from "components/badge/Badge";

function PlayerSlots(props: any) {
  const isPlayerClickable = typeof props.onPlayerClick === "function";

  return (
    <div className={classNames("player-slots-card", props?.className as string)}>
      <div
        className={classNames("player-slots-card-avatar", {
          "player-slots-card-avatar--clickable": isPlayerClickable,
        })}
        onClick={props.onPlayerClick}
      >
        <FontAwesomeIcon icon={["far", "user"]} size="lg" />
      </div>

      <div className="player-slots-card-content">
        <div className="player-slots-card-header">
          <p
            className={classNames("player-slots-card-name", {
              "player-slots-card-name--clickable": isPlayerClickable,
            })}
            onClick={props.onPlayerClick}
          >
            {props.name}
          </p>
          {props.customerType && !props.isGuest && (
            <Badge size="medium" type="gray"> {props.customerType} </Badge>
          )}

        {props.isGuest && (
            <Badge size="medium" type="gray"> {"Guest"} </Badge>
          )}
        </div>

        <div className="player-slots-card-email-row">
          <p className="player-slots-card-email">{props.email}</p>
        </div>

        {props.phone && <p className="player-slots-card-phone">{props.phone}</p>}
      </div>
      {props?.closable && (
            <ButtonNew className="ml-auto " type="secondary" size="small" onClick={props.removeGolfer}>
              <FontAwesomeIcon icon={faTrashCan} style={{fontSize: "18px"}} />
            </ButtonNew>
          )}
    </div>
  );
}

export default PlayerSlots;
